import axios from "axios";

const baseURL = `/api/v1/users_explore`;

const fetchCdes = (id, page = 1, per_page = 10, search = "") =>
  axios.get(`${baseURL}/${id}/cde_definitions`, {
    params: { page, per_page, search },
  });

const fetchDataSources = (id, page = 1, per_page = 10, search = "") =>
  axios.get(`${baseURL}/${id}/data_sources`, {
    params: { page, per_page, search },
  });

const fetchBusinessTerms = (id, page = 1, per_page = 10, search = "") =>
  axios.get(`${baseURL}/${id}/business_terms`, {
    params: { page, per_page, search },
  });

const fetchReferenceSources = (id, page = 1, per_page = 10, search = "") =>
  axios.get(`${baseURL}/${id}/reference_sources`, {
    params: { page, per_page, search },
  });

const usersExploreApi = {
  fetchCdes,
  fetchDataSources,
  fetchReferenceSources,
  fetchBusinessTerms,
};

export default usersExploreApi;
